const AlimLoader=({loaderMsg, postionParam})=>{
    return(
        <div id={"alimLoader"} className={`flex p-2 space-x-2 items-center justify-center w-fit relative pl-[30px] ${postionParam?postionParam:`mx-auto`}`}>
            <span className="alim-pre-loader animate-spin absolute md:relative left-0"></span>
            <span className="alim-text-color-style text-2xl font-bold">{loaderMsg}</span>
        </div>
    );
}

export default AlimLoader;